import { render } from "./SocialLinks.vue?vue&type=template&id=3ffd4be4"
import script from "./SocialLinks.vue?vue&type=script&lang=js"
export * from "./SocialLinks.vue?vue&type=script&lang=js"

import exportComponent from "/home/lie/repo/blisspot_vue_app/nuron-vuejs/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__